import { useCallback, useState } from 'react';
import { nextTick } from "../functions/nextTick.js";
export const useThemeColors = () => {
  const [themeColors, setThemeColors] = useState([]);
  const computeThemeColors = useCallback(async elm => {
    if (elm) {
      await nextTick();
      const computedStyle = getComputedStyle(elm);
      const primary = computedStyle.getPropertyValue('--color-picker-color-primary').toUpperCase();
      const secondary = computedStyle.getPropertyValue('--color-picker-color-secondary').toUpperCase();
      const tertiary = computedStyle.getPropertyValue('--color-picker-color-tertiary').toUpperCase();
      setThemeColors([primary, secondary, tertiary].filter(Boolean));
    }
  }, []);
  return {
    themeColors,
    computeThemeColors
  };
};